import { gql, TypedDocumentNode } from '@apollo/client'
import { SavePreferencesResponse, PreferencesMutationVariables } from './types'

export const SAVE_PREFERENCES: TypedDocumentNode<SavePreferencesResponse, PreferencesMutationVariables> = gql`
  mutation savePreferences($input: PreferencesInput!) {
    savePreferences(input: $input) {
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on SavePreferencesSuccess {
        preferences {
          id
          filters
        }
      }
    }
  }
`
